import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import PictureChoosing from './PictureChoosing/PictureChoosing.jsx';
import { ImageAndCategoriesBlock, SettingsBlock } from './Blocks/index.jsx';
import LanguageBlock from '../../SharedComponents/LanguageBlock.jsx';
import FormWrapper from '../../SharedComponents/FormWrapper.jsx';
import { IMAGES } from '../../../../../utils/constants/insight_constants.js';
import { useTranslation } from 'react-i18next';
import TranslationProviderBlock from '../../../../common/TranslationProviderBlock/TranslationProviderBlock.jsx';

const NewsForm = ({
  initials,
  displayTopOptions,
  creator,
  categories,
  handleSubmit,
  isEdit,
  visibleElement,
  setVisibleElement,
  setFormDisabledStates,
}) => {
  const [form] = Form.useForm();


  const { t } = useTranslation();
  return (
    <FormWrapper
      initials={initials}
      creator={creator}
      onSubmit={handleSubmit}
      directory={'news'}
      visibleElement={visibleElement}
      setVisibleElement={setVisibleElement}
      setFormDisabledStates={setFormDisabledStates}
      form={form}
    >
      <LanguageBlock language="sk" title={t('Slovenská verzia')} />
      <TranslationProviderBlock
        form={form}
        srcLang="sk"
        fields={['title','content']}
        targetLang="en"
      />

      <LanguageBlock
        language="en"
        title={t('Anglická verzia')}
        closedByDefault={initials.title_en == null}
      />
      <ImageAndCategoriesBlock
        categories={categories}
        onImageCardOpen={() => setVisibleElement(IMAGES)}
      />
      <SettingsBlock
        isEdit={isEdit}
        displayTopOptions={displayTopOptions}
        dateOfCreate={form.getFieldValue('valid_from')}
        creator={creator}
        form={form}
      />

      <PictureChoosing
        isOpen={visibleElement === IMAGES}
        onClose={() => setVisibleElement(undefined)}
        form={form}
      />
    </FormWrapper>
  );
};

NewsForm.propTypes = {
  initials: PropTypes.object,
  displayTopOptions: PropTypes.bool,
  creator: PropTypes.string,
  categories: PropTypes.array,
  handleSubmit: PropTypes.func,
  isEdit: PropTypes.bool,
  visibleElement: PropTypes.any,
  setVisibleElement: PropTypes.func,
  setFormDisabledStates: PropTypes.func,
};

export default NewsForm;
